import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-730e37a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-staff-wrapper pr-6" }
const _hoisted_2 = { class: "list-staff-body" }
const _hoisted_3 = { class: "long-text" }
const _hoisted_4 = { class: "long-text" }
const _hoisted_5 = { class: "w-full flex justify-content-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "w-full flex justify-content-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "w-full pr-3 flex justify-content-end gap-3" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import { AxiosResponse } from "axios";
import { get, set } from "@vueuse/core";
import { computed, inject, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "@/clinic/constants/router.constants";
import { StaffServices } from "@/clinic/services";
import type { ApiBasePaginatorReq, ApiBaseReq, ApiBaseReqParams, ApiStaffIndexRes, IStaff } from "@/clinic/typings";
import { PageState } from "primevue/paginator";
import Header from "@/clinic/components/atoms/Grid/header.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import Toast from "primevue/toast";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

type IColumn = {
  field: string;
  header: string;
  class?: string;
  style?: string;
  icon?: unknown;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const confirm = useConfirm();
const toast = useToast();
const store = useStore();

const first = ref(0);
const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const page = ref(0);
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);
const clinicId = ref(0);
const staffs = ref<IStaff[]>([]);
const searchTerm = ref("");

const columns = ref<IColumn[]>([
  { field: "id", header: "スタッフID", class: "col-1" },
  { field: "name_kanji", header: "名前", class: "col-2" },
  {
    field: "email",
    header: "メールアドレス",
    class: "col-3 pr-3",
  },
  { field: "position", header: "役職", class: "col-2 px-5" },
  { field: "comments", header: "コメント", class: "col-3 pl-3" },
  { field: "actions", header: "" },
]);

const isUnaffiliated = () => {
  return store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated;
};

const clinicIdParams = async (): Promise<ApiBaseReq> => ({ clinic_id: get(await get(clinicId)) });

const paginatorParams = computed(
  (): ApiBasePaginatorReq =>
    ({
      term: get(searchTerm),
      page: get(page) + 1, // バックエンドは1ベースのページ番号を期待
      rows: get(rows),
    } as ApiBasePaginatorReq)
);

const paging = async (fromId: string, { page: newPage, first: newFirst }: PageState) => {
  // 現在のページと同じ場合は何もしない
  if (newPage === get(page)) return;

  // ページ番号を更新
  set(page, newPage);

  // firstの値を更新（PrimeVueから渡された値を使用）
  set(first, newFirst);

  await loadStaffs();
};

const moveToNewStaff = () => RouterUtils.goTo(RouterConstants.STAFF_NEW_ROUTER_NAME);

const loadStaffs = async () => {
  const params = {
    ...(await clinicIdParams()),
    ...get(paginatorParams),
  } as ApiBaseReqParams;

  const { data } = (await StaffServices.getStaffs(params)) as unknown as AxiosResponse<ApiStaffIndexRes>;
  const { staffs: staffsData, meta } = get(data);
  const { total_count } = meta;
  set(staffs, get(staffsData));
  set(totalCount, get(total_count));
};

const onSearch = async (event: Event) => {
  const target = event.currentTarget as HTMLInputElement;
  set(searchTerm, target?.value || "");
  // 検索時はページをリセット
  set(page, 0);
  set(first, 0);
  await loadStaffs();
};

const loadList = async () => {
  set(clinicId, await inject("clinicId"));
  await loadStaffs();
};

const editStaff = (event: Event, templateId: number) => {
  event.stopPropagation();
  RouterUtils.goToWithParams(RouterConstants.STAFF_EDIT_ROUTER_NAME, { id: templateId });
};

const deleteStaff = (event: Event, templateId: number) => {
  event.stopPropagation();

  confirm.require({
    message: "このスタッフを削除してもよろしいでしょうか ?",
    header: "スタッフ削除",
    rejectLabel: "キャンセル",
    acceptLabel: "削除",
    acceptClass: "p-button-danger",
    accept: async () => {
      await StaffServices.trashStaff(
        get(templateId),
        {
          clinic_id: get(await get(clinicId)),
        },
        async () => {
          notifySuccessMsg(toast, "スタッフ追加に成功しました。");
          await loadStaffs();
        },
        () => notityErrorMsg(toast, "エラー")
      );
    },
  });
};
onBeforeMount(() => loadList());

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      enableSearch: "",
      searchPlaceholder: "スタッフの名前",
      createButtonLabel: "スタッフ新規作成",
      enableCreate: isUnaffiliated(),
      onSearch: onSearch,
      onNew: moveToNewStaff
    }, _createSlots({ _: 2 }, [
      (isUnaffiliated())
        ? {
            name: "otherButtons",
            fn: _withCtx(() => [
              _createVNode(_component_Button, {
                label: "出勤タイプ登録",
                class: "mr-0 btn-orange",
                onClick: _ctx.onGotoShiftTemplates
              }, null, 8, ["onClick"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["enableCreate"]),
    _createElementVNode("div", _hoisted_2, [
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            id: "pg-top",
            ref_key: "pgTop",
            ref: pgTop,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            paginatorId: "pg-top"
          }, null, 8, ["modelValue", "totalRecords", "rows"]))
        : _createCommentVNode("", true),
      _createVNode(Grid, {
        items: staffs.value,
        columns: columns.value
      }, _createSlots({
        comments: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(data.comments), 1)
        ]),
        position: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(data.position), 1)
        ]),
        _: 2
      }, [
        (isUnaffiliated())
          ? {
              name: "template_shifts",
              fn: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", {
                    class: "icon icon-calendar-month-svg cursor-pointer",
                    onClick: ($event: any) => (_ctx.onToggleWorkingShiftDialog(data))
                  }, null, 8, _hoisted_6)
                ])
              ]),
              key: "0"
            }
          : undefined,
        (isUnaffiliated())
          ? {
              name: "special_shifts",
              fn: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", {
                    class: "icon icon-calendar-day-svg cursor-pointer",
                    onClick: ($event: any) => (_ctx.onToggleSpecialShiftDialog(data))
                  }, null, 8, _hoisted_8)
                ])
              ]),
              key: "1"
            }
          : undefined,
        (isUnaffiliated())
          ? {
              name: "actions",
              fn: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", {
                    class: "pi pi-pencil text-green-600",
                    onClick: ($event: any) => (editStaff($event, data.id))
                  }, null, 8, _hoisted_10),
                  _createElementVNode("span", {
                    class: "pi pi-trash text-red-600",
                    onClick: ($event: any) => (deleteStaff($event, data.id))
                  }, null, 8, _hoisted_11)
                ])
              ]),
              key: "2"
            }
          : undefined
      ]), 1032, ["items", "columns"]),
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 1,
            id: "pg-bot",
            ref_key: "pgBot",
            ref: pgBot,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            class: "mt-2",
            paginatorId: "pg-bot"
          }, null, 8, ["modelValue", "totalRecords", "rows"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})